import * as React from "react";

const GooglePlayImg: React.FC<React.SVGProps<SVGElement>> = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="123"
        height="40"
        fill="none"
        viewBox="0 0 123 40"
    >
        <g clipPath="url(#clip0_4_68)">
            <path
                fill="#000"
                d="M117 0H6a6 6 0 0 0-6 6v28a6 6 0 0 0 6 6h111a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6"
            ></path>
            <path
                fill="#fff"
                stroke="#fff"
                strokeWidth="0.2"
                d="M33.74 14.42H33v-2.01h.59c.52-.45.77-1.21.76-2.3V7.15h4.01v5.26h.67v2.01h-.74v-1.27h-4.55zm1.39-4.3c.01.95-.18 1.71-.57 2.3h3.03V7.89h-2.46zm9.91 2.25c-.59.61-1.32.91-2.2.91s-1.61-.3-2.2-.91-.88-1.35-.88-2.22.29-1.62.88-2.22c.59-.61 1.32-.91 2.2-.91.87 0 1.6.3 2.2.91.59.61.89 1.35.89 2.22 0 .88-.3 1.62-.89 2.22Zm-3.83-.5c.44.45.99.67 1.63.67s1.19-.22 1.63-.67.67-1.02.67-1.72-.22-1.27-.67-1.72c-.44-.45-.99-.67-1.63-.67s-1.19.22-1.63.67-.67 1.02-.67 1.72.23 1.27.67 1.72Zm8.6 1.41q-1.32 0-2.22-.9c-.6-.6-.9-1.34-.9-2.24s.3-1.64.9-2.24q.9-.9 2.22-.9c.9 0 1.64.33 2.2.98l-.54.52c-.41-.51-.96-.76-1.67-.76-.65 0-1.21.22-1.66.66s-.67 1.02-.67 1.73.22 1.29.67 1.73 1 .66 1.66.66c.72 0 1.33-.29 1.84-.87l.54.54c-.27.33-.62.59-1.03.78-.41.22-.86.31-1.34.31Zm5.5-.13h-.77V7.89h-1.68v-.74h4.12v.74H55.3v5.26zm6.97-6-2.27 5.06c-.31.71-.78 1.07-1.4 1.07-.18 0-.38-.04-.6-.13l.2-.71c.13.07.26.11.4.11.18 0 .32-.03.42-.1s.19-.2.27-.38l.22-.48-2.02-4.44h.91l1.48 3.44h.03l1.45-3.44zm.87 6v-6h4.34v6h-.77V7.89h-2.8v5.26zm5.71 0v-6h.77v2.57h3V7.15h.77v6h-.77v-2.71h-3v2.71zm10.83-.78c-.59.61-1.32.91-2.2.91s-1.61-.3-2.2-.91-.88-1.35-.88-2.22.29-1.62.88-2.22c.59-.61 1.32-.91 2.2-.91.87 0 1.6.3 2.2.91.59.61.89 1.35.89 2.22-.01.88-.3 1.62-.89 2.22Zm-3.83-.5c.44.45.99.67 1.63.67s1.19-.22 1.63-.67.67-1.02.67-1.72-.22-1.27-.67-1.72c-.44-.45-.99-.67-1.63-.67s-1.19.22-1.63.67-.67 1.02-.67 1.72.22 1.27.67 1.72Zm7.86 1.28v-6h2.17c.47 0 .88.16 1.22.46.34.31.52.7.52 1.17 0 .29-.07.54-.22.75-.15.22-.34.38-.59.49v.03c.3.1.54.27.73.52s.29.53.29.86c0 .49-.18.9-.54 1.22s-.79.49-1.28.49h-2.3zm.77-3.43h1.4c.29 0 .52-.1.7-.29s.26-.4.26-.63-.08-.44-.26-.63a.85.85 0 0 0-.67-.29h-1.43zm0 2.69h1.55c.3 0 .54-.1.72-.31s.28-.43.28-.68a.91.91 0 0 0-.29-.67 1 1 0 0 0-.75-.31h-1.52v1.97z"
            ></path>
            <path
                fill="#fff"
                d="M60.1 21.7c-2.35 0-4.27 1.79-4.27 4.25 0 2.45 1.92 4.25 4.27 4.25s4.27-1.8 4.27-4.25c0-2.46-1.92-4.25-4.27-4.25m0 6.83c-1.29 0-2.4-1.06-2.4-2.58 0-1.53 1.11-2.58 2.4-2.58s2.4 1.05 2.4 2.58c0 1.52-1.12 2.58-2.4 2.58m-9.32-6.83c-2.35 0-4.27 1.79-4.27 4.25 0 2.45 1.92 4.25 4.27 4.25s4.27-1.8 4.27-4.25c0-2.46-1.92-4.25-4.27-4.25m0 6.83c-1.29 0-2.4-1.06-2.4-2.58 0-1.53 1.11-2.58 2.4-2.58s2.4 1.05 2.4 2.58c0 1.52-1.11 2.58-2.4 2.58M39.7 23.01v1.8h4.32c-.13 1.01-.47 1.76-.98 2.27-.63.63-1.61 1.32-3.33 1.32-2.66 0-4.74-2.14-4.74-4.8s2.08-4.8 4.74-4.8c1.43 0 2.48.56 3.25 1.29l1.27-1.27C43.15 17.79 41.72 17 39.7 17c-3.64 0-6.7 2.96-6.7 6.61 0 3.64 3.06 6.61 6.7 6.61 1.97 0 3.45-.64 4.61-1.85 1.19-1.19 1.56-2.87 1.56-4.22 0-.42-.03-.81-.1-1.13H39.7zm45.31 1.4c-.35-.95-1.43-2.71-3.64-2.71-2.19 0-4.01 1.72-4.01 4.25 0 2.38 1.8 4.25 4.22 4.25 1.95 0 3.08-1.19 3.54-1.88l-1.45-.97c-.48.71-1.14 1.18-2.09 1.18s-1.63-.44-2.06-1.29l5.69-2.35zm-5.8 1.42c-.05-1.64 1.27-2.48 2.22-2.48.74 0 1.37.37 1.58.9zm-4.62 4.12h1.87v-12.5h-1.87zm-3.06-7.3h-.07c-.42-.5-1.22-.95-2.24-.95-2.13 0-4.08 1.87-4.08 4.27 0 2.38 1.95 4.24 4.08 4.24 1.01 0 1.82-.45 2.24-.97h.06v.61c0 1.63-.87 2.5-2.27 2.5-1.14 0-1.85-.82-2.14-1.51l-1.63.68c.47 1.13 1.71 2.51 3.77 2.51 2.19 0 4.04-1.29 4.04-4.43v-7.64h-1.77v.69zm-2.15 5.88c-1.29 0-2.37-1.08-2.37-2.56 0-1.5 1.08-2.59 2.37-2.59 1.27 0 2.27 1.1 2.27 2.59.01 1.48-.99 2.56-2.27 2.56m24.39-11.08H89.3v12.5h1.87v-4.74h2.61c2.07 0 4.1-1.5 4.1-3.88s-2.05-3.88-4.11-3.88m.04 6.02h-2.65v-4.29h2.65c1.4 0 2.19 1.16 2.19 2.14s-.79 2.15-2.19 2.15m11.54-1.79c-1.35 0-2.75.6-3.33 1.91l1.66.69c.35-.69 1.01-.92 1.7-.92.96 0 1.95.58 1.96 1.61v.13c-.34-.19-1.06-.48-1.95-.48-1.79 0-3.6.98-3.6 2.81 0 1.67 1.46 2.75 3.1 2.75 1.25 0 1.95-.56 2.38-1.22h.06v.97h1.8v-4.79c.01-2.22-1.65-3.46-3.78-3.46m-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-.96 1.06-1.33 1.98-1.33.82 0 1.21.18 1.7.42a2.255 2.255 0 0 1-2.22 1.97m10.58-6.58-2.14 5.42h-.06l-2.22-5.42h-2.01l3.33 7.58-1.9 4.21h1.95l5.13-11.79zm-16.8 8h1.87v-12.5H98.9z"
            ></path>
            <path
                fill="url(#paint0_linear_4_68)"
                d="M8.364 7.329C8.091 7.609 8 8.075 8 8.634V29.24c0 .56.182 1.026.456 1.305l.09.094 11.298-11.561v-.187z"
            ></path>
            <path
                fill="url(#paint1_linear_4_68)"
                d="m23.488 22.993-3.735-3.823v-.28l3.735-3.822.091.093 4.464 2.61c1.276.746 1.276 1.958 0 2.704z"
            ></path>
            <path
                fill="url(#paint2_linear_4_68)"
                d="m23.58 22.9-3.827-3.917L8.364 30.638c.456.466 1.094.466 1.914.093z"
            ></path>
            <path
                fill="url(#paint3_linear_4_68)"
                d="m23.58 15.068-13.302-7.74c-.82-.465-1.458-.372-1.914.094l11.389 11.561z"
            ></path>
            <path
                fill="#000"
                d="m23.488 22.806-13.21 7.645c-.73.466-1.367.373-1.822 0l-.092.093.092.094c.455.373 1.093.466 1.822 0z"
                opacity="0.2"
            ></path>
            <path
                fill="#000"
                d="M8.364 30.451c-.273-.28-.364-.746-.364-1.305v.093c0 .56.182 1.026.456 1.305v-.093zm19.68-10.256-4.556 2.611.091.093 4.464-2.61c.638-.373.911-.84.911-1.306 0 .466-.364.84-.91 1.212"
                opacity="0.12"
            ></path>
            <path
                fill="#fff"
                d="m10.278 7.422 17.765 10.35c.547.372.911.745.911 1.211 0-.466-.273-.932-.91-1.305L10.277 7.328C9.002 6.584 8 7.143 8 8.635v.093c0-1.398 1.002-2.05 2.278-1.305"
                opacity="0.25"
            ></path>
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_4_68"
                x1="18.75"
                x2="3.107"
                y1="8.457"
                y2="23.742"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00A0FF"></stop>
                <stop offset="0.007" stopColor="#00A1FF"></stop>
                <stop offset="0.26" stopColor="#00BEFF"></stop>
                <stop offset="0.512" stopColor="#00D2FF"></stop>
                <stop offset="0.76" stopColor="#00DFFF"></stop>
                <stop offset="1" stopColor="#00E3FF"></stop>
            </linearGradient>
            <linearGradient
                id="paint1_linear_4_68"
                x1="29.714"
                x2="7.669"
                y1="18.984"
                y2="18.984"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFE000"></stop>
                <stop offset="0.409" stopColor="#FFBD00"></stop>
                <stop offset="0.775" stopColor="orange"></stop>
                <stop offset="1" stopColor="#FF9C00"></stop>
            </linearGradient>
            <linearGradient
                id="paint2_linear_4_68"
                x1="21.508"
                x2="0.296"
                y1="21.124"
                y2="41.852"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF3A44"></stop>
                <stop offset="1" stopColor="#C31162"></stop>
            </linearGradient>
            <linearGradient
                id="paint3_linear_4_68"
                x1="5.537"
                x2="15.01"
                y1="0.5"
                y2="9.757"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#32A071"></stop>
                <stop offset="0.069" stopColor="#2DA771"></stop>
                <stop offset="0.476" stopColor="#15CF74"></stop>
                <stop offset="0.801" stopColor="#06E775"></stop>
                <stop offset="1" stopColor="#00F076"></stop>
            </linearGradient>
            <clipPath id="clip0_4_68">
                <path fill="#fff" d="M0 0h123v40H0z"></path>
            </clipPath>
        </defs>
    </svg>
);

export default GooglePlayImg;
